/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ keyName: NonNullable<unknown> }} Settings_Reportingapikeys_Generate_Reactivatewarning3Inputs */

const en_settings_reportingapikeys_generate_reactivatewarning3 = /** @type {(inputs: Settings_Reportingapikeys_Generate_Reactivatewarning3Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`A key named ${i?.keyName} already exists for this user in a deactivated state. Generating will replace it and also re-activate a key that was previously deactivated.`)
};

/**
* | output |
* | --- |
* | "A key named {keyName} already exists for this user in a deactivated state. Generating will replace it and also re-activate a key that was previously deactiva..." |
*
* @param {Settings_Reportingapikeys_Generate_Reactivatewarning3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const settings_reportingapikeys_generate_reactivatewarning3 = /** @type {((inputs: Settings_Reportingapikeys_Generate_Reactivatewarning3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Reportingapikeys_Generate_Reactivatewarning3Inputs, { locale?: "en" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_settings_reportingapikeys_generate_reactivatewarning3(inputs)
});
export { settings_reportingapikeys_generate_reactivatewarning3 as "settings_reportingApiKeys_generate_reactivateWarning" }